module.exports = __webpack_public_path__ + "static-v-shop/1791260809989/img/logo_cabal.f797e5ff.png";